export const fr = {
    ReviewCyclesList: {
        totalCount_one: "{{count}} cycle d'évaluation",
        totalCount_other: "{{count}} cycles d'évaluation",
        noData: "Aucun cycle d'évaluation n'a encore été créé.",
        noResults: "Aucun cycle d'évaluation correspondant",
        noResultsHint: "Essayez un autre terme de recherche ou retirez des filtres.",
        error: "Impossible de charger les cycles d'évaluation",
        liveRegion: {
            loading: "Chargement des cycles d'évaluation",
            loadingMoreAnnouncement: "Chargement d'autres cycles d'évaluation",
            loadedMore_one: "{{count}} cycle d'évaluation supplémentaire chargé",
            loadedMore_other: "{{count}} cycles d'évaluation supplémentaires chargés",
            results_one: "{{count}} cycle d'évaluation",
            results_other: "{{count}} cycles d'évaluation"
        }
    },
    ReviewCyclesTable: {
        ariaLabel: "Cycles d'évaluation",
        columns: {
            name: "Cycle",
            state: "État",
            reviewees: "Évaluées",
            reviewTypes: "Types",
            progress: "Progression",
            evaluationPeriod: "Période",
            creator: "Créé par",
            actions: "Actions"
        },
        unknownCreator: "Inconnu",
        untitled: "Cycle d'évaluation sans titre",
        noEvaluationPeriod: "—",
        progressLabel: "{{submitted}} évaluation(s) soumise(s) sur {{total}}",
        noProgress: "Non commencé"
    },
    ReviewCyclesToolbar: {
        searchPlaceholder: "Rechercher un cycle d'évaluation",
        searchAriaLabel: "Rechercher un cycle d'évaluation",
        resetFilters: "Réinitialiser les filtres",
        addFilter: "Ajouter un filtre",
        quickFilters: "Filtres rapides",
        filtersHeading: "Filtres",
        applied: "Appliqué",
        removeFilter: "Retirer le filtre",
        chipAriaLabel: "{{kind}} : {{value}}. Modifier ou retirer ce filtre",
        valueCount_one: "{{count}} sélectionné",
        valueCount_other: "{{count}} sélectionnés",
        filters: {
            back: "Retour aux filtres",
            noOptions: "Rien à filtrer pour l'instant",
            noMatches: "Aucun résultat",
            participant: "Participant",
            participantSearchPlaceholder: "Rechercher des personnes",
            participantLoading: "Chargement des personnes",
            participantNoResults: "Aucune personne correspondante",
            participantResults_one: "{{count}} personne",
            participantResults_other: "{{count}} personnes",
            evaluationPeriod: "Période d'évaluation",
            evaluationPeriodHint: "Affiche les cycles évaluant une partie de l'année sélectionnée.",
            reviewType: "Type d'évaluation",
            creator: "Créé par",
            creatorSearchPlaceholder: "Rechercher un créateur",
            state: "État du cycle"
        },
        presets: {
            "all-active": "Tous les cycles lancés",
            "involving-me": "Cycles lancés me concernant",
            "created-by-me": "Cycles que j'ai créés"
        }
    },
    CreateReviewCycleButton: {
        label: "Nouveau cycle d'évaluation"
    },
    CycleStateBadge: {
        draft: "Brouillon",
        scheduled: "Planifié",
        active: "Lancé",
        locked: "Verrouillé"
    },
    CycleReviewTypeBadge: {
        self: "Auto",
        manager: "Gestionnaire",
        peer: "Pairs",
        upward: "Ascendante"
    },
    CycleNudgeButton: {
        label: "Envoyer un rappel",
        unavailable: {
            draft: "Ce cycle n'est pas encore lancé : il n'y a personne à relancer.",
            locked: "Ce cycle est verrouillé : il n'y a plus rien à soumettre."
        }
    },
    CycleNudgeDialog: {
        title: "Envoyer un rappel",
        description: "Lorsque vous envoyez un rappel, chaque participant reçoit la liste des tâches qu'il lui reste à terminer.",
        nudgeToHeading: "Rappeler aux personnes de :",
        loading: "Vérification de ce qui est en attente",
        loadFailed: "Nous n'avons pas pu vérifier ce qui est en attente. Fermez et réessayez.",
        nothingToRemind: "Rien n'est en attente dans ce cycle pour l'instant.",
        nudgeTo: {
            "self-review": "Compléter leur auto-évaluation",
            "manager-review": "Compléter leurs évaluations de gestionnaire",
            "peer-review": "Compléter leurs évaluations de pairs",
            "upward-review": "Compléter leurs évaluations ascendantes",
            "not-shared": "Partager les résultats avec la personne évaluée",
            "not-acknowledged": "Confirmer leur évaluation"
        },
        reminderType: {
            "self-review": "les auto-évaluations",
            "manager-review": "les évaluations du gestionnaire",
            "peer-review": "les évaluations des pairs",
            "upward-review": "les évaluations ascendantes",
            "not-shared": "les résultats non partagés",
            "not-acknowledged": "les évaluations non confirmées"
        },
        due: {
            daysLeft_one: "{{count}} jour restant",
            daysLeft_other: "{{count}} jours restants",
            today: "Échéance aujourd'hui",
            overdue_one: "En retard de {{count}} jour",
            overdue_other: "En retard de {{count}} jours"
        },
        sentRecentlyBadge: "Envoyé récemment",
        recipients: {
            count_one: "{{count}} personne",
            count_other: "{{count}} personnes",
            none: "Personne en attente",
            loading: "Chargement des destinataires",
            error: "Nous n'avons pas pu charger les destinataires.",
            andMore_one: "et {{count}} autre",
            andMore_other: "et {{count}} autres"
        },
        recentlySent_one: "Un rappel a déjà été envoyé au cours des {{hours}} dernières heures pour : {{types}}. Un nouvel envoi relancera les mêmes personnes une deuxième fois.",
        recentlySent_other: "Des rappels ont déjà été envoyés au cours des {{hours}} dernières heures pour : {{types}}. Un nouvel envoi relancera les mêmes personnes une deuxième fois.",
        message: {
            label: "Ajouter un message à votre rappel",
            sentAs: "Ce message sera envoyé au nom de",
            placeholder: "Des tâches d'évaluation requièrent encore votre attention. Veuillez les compléter dès que possible."
        },
        sendToCount_one: "Relancer {{count}} personne",
        sendToCount_other: "Relancer {{count}} personnes",
        sentToast_one: "Rappel envoyé à {{count}} personne.",
        sentToast_other: "Rappels envoyés à {{count}} personnes.",
        sendFailedToast: "Nous n'avons pas pu envoyer les rappels. Veuillez réessayer.",
        cancel: "Annuler",
        send: "Envoyer les rappels",
        sending: "Envoi en cours…"
    },
    CycleActionsMenu: {
        ariaLabel: "Actions pour {{name}}",
        cancel: "Annuler",
        unavailable: {
            locked: "Ce cycle est verrouillé.",
            notLaunched: "Ce cycle n'est pas encore lancé."
        },
        edit: { label: "Modifier" },
        view: { label: "Voir" },
        duplicate: {
            label: "Dupliquer",
            success: "Cycle dupliqué",
            error: "Votre cycle n'a pas pu être dupliqué. Veuillez réessayer."
        },
        lock: {
            label: "Fermer et verrouiller",
            title: "Verrouiller ce cycle?",
            description: "Verrouiller ce cycle empêchera toute nouvelle soumission ou re-soumission et toute modification du cycle.",
            descriptionUnsubmitted_one: "{{count}} évaluation doit encore être soumise. Verrouiller ce cycle empêchera toute nouvelle soumission ou re-soumission et toute modification du cycle.",
            descriptionUnsubmitted_other: "{{count}} évaluations doivent encore être soumises. Verrouiller ce cycle empêchera toute nouvelle soumission ou re-soumission et toute modification du cycle.",
            confirm: "Verrouiller",
            success: "Cycle verrouillé",
            error: "Votre cycle n'a pas pu être verrouillé. Veuillez réessayer."
        },
        unlock: {
            label: "Déverrouiller",
            title: "Déverrouiller ce cycle?",
            description: "Déverrouiller ce cycle permettra de soumettre ou re-soumettre des évaluations, ainsi que de modifier le cycle.",
            confirm: "Déverrouiller",
            success: "Cycle déverrouillé",
            error: "Votre cycle n'a pas pu être déverrouillé. Veuillez réessayer."
        },
        delete: {
            label: "Supprimer",
            title: "Supprimer {{name}}?",
            description: "Cette action est permanente et irréversible. Toutes les évaluations seront définitivement supprimées et les fonctionnalités comme l'export et la calibration ne seront plus disponibles pour ce cycle.",
            confirmation: "Je comprends",
            confirm: "Supprimer",
            success: "Cycle supprimé",
            error: "Votre cycle n'a pas pu être supprimé. Veuillez réessayer."
        }
    },
    CycleDetailHeader: {
        status: "Statut",
        evaluationPeriod: "Période d'évaluation",
        launchDate: "Lancé le",
        lockedDate: "Verrouillé le",
        automatedStartDate: "Débute le",
        creator: "Créé par",
        unknownCreator: "Inconnu"
    },
    CycleExportMenu: {
        label: "Exporter",
        preparing: "Préparation…",
        failed: "Impossible de préparer cette exportation. Réessayez.",
        group: {
            allReviews: "Toutes les évaluations",
            report: "Rapport — {{tab}}"
        },
        item: {
            "all-reviews-pdf": "Un fichier par personne évaluée",
            "all-reviews-csv": "Tout dans un seul fichier",
            "report-pdf": "Graphiques et tableaux",
            "report-csv": "Données brutes"
        },
        tab: {
            progression: "Progression",
            scores: "Scores",
            questions: "Résultats par question",
            calibration: "Calibration",
            themes: "Thèmes"
        },
        liveRegion: {
            preparing: "Préparation de votre exportation."
        }
    },
    CycleProgressTracker: {
        typeLabel: "Évaluations {{type}}",
        submittedOf: "Soumises ({{submitted}}/{{total}})",
        distributionLabel: "{{type}} : {{breakdown}}",
        distributionBand: "{{percent}} % {{label}} ({{value}} sur {{total}})",
        dueOn: "Échéance : {{date}}"
    },
    CycleRevieweesTable: {
        ariaLabel: "Personnes évaluées",
        columns: {
            reviewee: "Personne évaluée",
            state: "État",
            delivery: "Remise",
            sortState: {
                ascending: "(tri croissant)",
                descending: "(tri décroissant)"
            }
        },
        cell: {
            noReview: "{{type}} : aucun évaluateur assigné",
            status: "{{type}} : {{status}}",
            submittedOf: "{{type}} : {{submitted}} soumises sur {{total}}",
            noPacket: "Remise : rien à remettre pour l'instant"
        },
        expandRow: "Afficher les évaluations de {{name}}",
        collapseRow: "Masquer les évaluations de {{name}}",
        drawerRow: "Évaluations de {{name}}",
        selectAll: "Sélectionner toutes les personnes évaluées"
    },
    CycleRosterSelectionBar: {
        selectedCount_one: "{{count}} sélectionnée",
        selectedCount_other: "{{count}} sélectionnées",
        allSelected: "Toutes les personnes évaluées sélectionnées",
        allSelectedWithCount_one: "{{count}} personne évaluée sélectionnée (toutes)",
        allSelectedWithCount_other: "Les {{count}} personnes évaluées sélectionnées",
        share: "Partager",
        unshare: "Retirer le partage",
        remove: "Retirer",
        unavailable: {
            locked: "Ce cycle est verrouillé.",
            unknownCycle: "Chargement du cycle en cours.",
            nothingShareable: "Seules les évaluations soumises peuvent être partagées, et aucune des évaluations sélectionnées ne l'est.",
            acknowledgmentRequired: "Ce cycle exige une confirmation : le partage ne peut pas être retiré.",
            nothingUnshareable: "Seules les évaluations partagées peuvent être retirées du partage, et aucune des évaluations sélectionnées ne l'est."
        }
    },
    CycleAddRevieweesDialog: {
        title: "Ajouter des personnes évaluées",
        description: "Sélectionnez les personnes ou les segments que vous souhaitez ajouter à ce cycle d’évaluation. Les règles du cycle déterminent le moment où chacune y entre.",
        searchLabel: "Rechercher des personnes et des segments",
        searchPlaceholder: "Rechercher par nom",
        searchLoading: "Recherche en cours…",
        searchNoResults: "Aucune personne correspondante.",
        searchFailed: "Nous n’avons pas pu charger la liste. Vérifiez votre connexion et relancez la recherche.",
        staleError: "Impossible d'actualiser — affichage des derniers résultats.",
        searchResults_one: "{{count}} résultat",
        searchResults_other: "{{count}} résultats",
        liveRegion: {
            loadedMorePeople_one: "{{count}} personne supplémentaire chargée",
            loadedMorePeople_other: "{{count}} personnes supplémentaires chargées",
            loadedMoreSegments_one: "{{count}} segment supplémentaire chargé",
            loadedMoreSegments_other: "{{count}} segments supplémentaires chargés"
        },
        peopleHeading: "Personnes",
        segmentsHeading: "Segments",
        loadMorePeople: "Afficher plus de personnes",
        loadMoreSegments: "Afficher plus de segments",
        segmentOption_one: "{{name}} · {{count}} membre",
        segmentOption_other: "{{name}} · {{count}} membres",
        segmentTag_one: "{{name}} ({{count}})",
        segmentTag_other: "{{name}} ({{count}})",
        pickedMembers_one: "{{count}} personne sélectionnée",
        pickedMembers_other: "{{count}} personnes sélectionnées",
        pickedSegments_one: "{{count}} segment sélectionné",
        pickedSegments_other: "{{count}} segments sélectionnés",
        segmentCaveat: "Le nombre de membres d’un segment correspond à sa population entière. Le nombre d’entre eux qui rejoindront ce cycle dépend des règles du cycle — le sommaire affiché après l’ajout le précisera.",
        cancel: "Annuler",
        confirm: "Ajouter des personnes évaluées",
        adding: "Ajout en cours…",
        failedToast: "Nous n’avons pas pu ajouter ces personnes évaluées. Réessayez.",
        forbiddenToast: "Ce cycle est verrouillé; ses personnes évaluées ne peuvent pas être modifiées.",
        outcome: {
            title: "Personnes évaluées ajoutées",
            noChangesTitle: "Personne n’a été ajouté",
            description: "Les personnes et les segments que vous avez sélectionnés ont été appliqués à ce cycle d’évaluation.",
            nothingToReport: "Rien n’a changé pour les personnes que vous avez sélectionnées.",
            groups: {
                added_one: "{{count}} personne a rejoint le cycle immédiatement.",
                added_other: "{{count}} personnes ont rejoint le cycle immédiatement.",
                addedUpcoming_one: "{{count}} personne entrera plus tard.",
                addedUpcoming_other: "{{count}} personnes entreront plus tard.",
                alreadyAdded_one: "{{count}} personne faisait déjà partie de ce cycle.",
                alreadyAdded_other: "{{count}} personnes faisaient déjà partie de ce cycle.",
                missingHireDate_one: "{{count}} personne n’a pas de date d’embauche et a été ignorée.",
                missingHireDate_other: "{{count}} personnes n’ont pas de date d’embauche et ont été ignorées.",
                unplaceable_one: "{{count}} personne n’a pas pu être ajoutée à ce cycle.",
                unplaceable_other: "{{count}} personnes n’ont pas pu être ajoutées à ce cycle."
            },
            nextEntry: "La première d’entre elles entre le {{date}}.",
            unnamed_one: "et {{count}} autre",
            unnamed_other: "et {{count}} autres",
            done: "OK"
        }
    },
    CycleRosterBulkActionDialog: {
        cancel: "Annuler",
        share: {
            title: "Partager ces évaluations ?",
            body: "Seules les évaluations soumises seront partagées.",
            visibilityHeading: "Ce que les personnes évaluées pourront voir :",
            visibility: {
                manager: "Les réponses du gestionnaire auxquelles elles ont accès",
                peerIdentified: "Les réponses des pairs auxquelles elles ont accès, avec le nom des évaluateurs",
                peerAnonymous: "Les réponses des pairs auxquelles elles ont accès, anonymisées",
                self: "Leurs propres réponses d'auto-évaluation",
                upwardIdentified: "Les réponses de l'évaluation ascendante auxquelles elles ont accès, avec le nom des évaluateurs",
                upwardAnonymous: "Les réponses de l'évaluation ascendante auxquelles elles ont accès, anonymisées"
            },
            laterEdits: "Toute modification faite après le partage sera également visible.",
            acknowledgmentNote: "Ce cycle exige une confirmation : une fois partagées, vous ne pourrez plus retirer le partage.",
            confirm: "Partager",
            pending: "Partage en cours…",
            doneToast: "Les évaluations ont été partagées.",
            doneToastWithCount_one: "L'évaluation de {{count}} personne a été partagée.",
            doneToastWithCount_other: "Les évaluations de {{count}} personnes ont été partagées.",
            failedToast: "Impossible de partager ces évaluations. Réessayez."
        },
        unshare: {
            title: "Retirer le partage de ces évaluations ?",
            body: "Seules les évaluations partagées seront retirées du partage. Les personnes évaluées ne pourront plus les consulter.",
            confirm: "Retirer le partage",
            pending: "Retrait du partage en cours…",
            doneToast: "Le partage des évaluations a été retiré.",
            doneToastWithCount_one: "Le partage de l'évaluation de {{count}} personne a été retiré.",
            doneToastWithCount_other: "Le partage des évaluations de {{count}} personnes a été retiré.",
            failedToast: "Impossible de retirer le partage de ces évaluations. Réessayez."
        },
        remove: {
            title: "Retirer ces personnes évaluées ?",
            body: "Cela masquera les évaluations rédigées à leur sujet dans ce cycle.",
            restorable: "Si elles sont réintégrées au cycle, ces évaluations redeviendront visibles.",
            acknowledgmentNote: "Les personnes ayant confirmé leur évaluation ne seront pas retirées.",
            confirm: "Retirer du cycle",
            pending: "Retrait en cours…",
            doneToast: "Les personnes évaluées ont été retirées du cycle.",
            doneToastWithCount_one: "{{count}} personne évaluée a été retirée du cycle.",
            doneToastWithCount_other: "{{count}} personnes évaluées ont été retirées du cycle.",
            failedToast: "Impossible de retirer ces personnes évaluées. Réessayez."
        }
    },
    CycleRevieweeRowMenu: {
        ariaLabel: "Actions pour {{name}}",
        temporaryManager: {
            label: "Assigner un gestionnaire temporaire",
            description: "Confier les tâches du gestionnaire à quelqu'un d'autre, pour ce cycle.",
            unavailable: {
                locked: "Ce cycle est verrouillé.",
                noManagerReview: "Ce cycle ne comporte aucune évaluation du gestionnaire.",
                unknownCycle: "Chargement du cycle en cours."
            }
        },
        peer: {
            assignLabel: "Assigner des évaluateurs pairs",
            assignDescription: "Choisissez qui rédigera les évaluations des pairs pour cette personne.",
            updateLabel: "Modifier les évaluateurs pairs",
            updateDescription: "Réassignez qui rédigera les évaluations des pairs pour cette personne.",
            unavailable: {
                locked: "Ce cycle est verrouillé.",
                acknowledged: "Cette évaluation a été confirmée : les évaluateurs pairs ne peuvent plus être modifiés.",
                unknownCycle: "Chargement du cycle en cours."
            }
        },
        upward: {
            assignLabel: "Assigner des évaluateurs ascendants",
            assignDescription: "Choisissez qui rédigera les évaluations ascendantes pour cette personne.",
            updateLabel: "Modifier les évaluateurs ascendants",
            updateDescription: "Réassignez qui rédigera les évaluations ascendantes pour cette personne.",
            unavailable: {
                locked: "Ce cycle est verrouillé.",
                acknowledged: "Cette évaluation a été confirmée : les évaluateurs ascendants ne peuvent plus être modifiés.",
                unknownCycle: "Chargement du cycle en cours."
            }
        },
        remove: {
            label: "Retirer du cycle d'évaluation",
            description: "Les évaluations concernant cette personne ne seront plus requises.",
            unavailable: {
                locked: "Ce cycle est verrouillé.",
                acknowledged: "Cette évaluation a été confirmée : la personne ne peut plus être retirée.",
                unknownCycle: "Chargement du cycle en cours."
            }
        }
    },
    CycleTemporaryManagerDialog: {
        title: "Réassigner les tâches de gestionnaire pour ce cycle d'évaluation",
        description: "Le gestionnaire temporaire peut assigner des pairs ainsi que rédiger et partager les évaluations de <strong>{{name}}</strong> pour ce cycle d'évaluation précis. Cette personne aura également accès à ses évaluations passées.",
        officialManagerHeading: "Gestionnaire officiel",
        currentHeading: "Gestionnaire temporaire",
        noneAssigned: "Personne — son gestionnaire habituel s'en charge.",
        clear: "Retirer",
        loadingCurrent: "Vérification de la personne assignée",
        loadCurrentFailed: "Nous n'avons pas pu charger la personne actuellement assignée : l'enregistrement est désactivé. Rouvrez la fenêtre pour réessayer.",
        searchPlaceholder: "Rechercher des personnes",
        searchLoading: "Recherche en cours",
        searchNoResults: "Aucune personne correspondante",
        searchResults_one: "{{count}} personne",
        searchResults_other: "{{count}} personnes",
        assignedToast: "{{manager}} agit maintenant comme gestionnaire de {{name}} pour ce cycle.",
        clearedToast: "Les tâches de gestionnaire de {{name}} sont revenues à son gestionnaire habituel.",
        saveFailedToast: "Nous n'avons pas pu enregistrer le gestionnaire temporaire. Réessayez.",
        cancel: "Annuler",
        save: "Assigner",
        saving: "Enregistrement en cours…"
    },
    CycleReviewerPickerDialog: {
        loadingCurrent: "Vérification des personnes assignées",
        loadCurrentFailed: "Nous n'avons pas pu charger les évaluateurs actuels : l'enregistrement est désactivé. Rouvrez la fenêtre pour réessayer.",
        chipRequests_one: "({{count}} demande)",
        chipRequests_other: "({{count}} demandes)",
        noneSelected: "Personne n'est encore assigné.",
        removeReviewer: "Retirer {{name}}",
        addDirectReports_one: "Ajouter la personne supervisée ({{count}})",
        addDirectReports_other: "Ajouter toutes les personnes supervisées ({{count}})",
        addReportingLine_one: "Ajouter la ligne hiérarchique ({{count}})",
        addReportingLine_other: "Ajouter toute la ligne hiérarchique ({{count}})",
        searchPlaceholder: "Rechercher des personnes",
        searchLoading: "Recherche en cours",
        searchNoResults: "Aucune personne correspondante",
        searchResults_one: "{{count}} personne",
        searchResults_other: "{{count}} personnes",
        alreadyAssigned_one: "{{count}} évaluation",
        alreadyAssigned_other: "{{count}} évaluations",
        loadMoreCandidates: "Afficher plus de personnes",
        cancel: "Annuler",
        saving: "Enregistrement en cours…",
        peer: {
            title_one: "Demander à {{count}} pair de remplir une évaluation",
            title_other: "Demander à {{count}} pairs de remplir une évaluation",
            description: "Déterminez les pairs les plus pertinents en confirmant avec <strong>{{name}}</strong> les personnes avec qui cette personne collabore ou interagit régulièrement.",
            fieldLabel: "Évaluateurs pairs",
            notificationHint: "Une notification sera envoyée aux pairs nouvellement assignés ainsi qu'à ceux qui ont été retirés.",
            totalSelected_one: "{{count}} pair sélectionné au total",
            totalSelected_other: "{{count}} pairs sélectionnés au total",
            save: "Mettre à jour",
            savedToast_one: "{{count}} évaluateur pair enregistré pour {{name}}.",
            savedToast_other: "{{count}} évaluateurs pairs enregistrés pour {{name}}.",
            saveFailedToast: "Nous n'avons pas pu enregistrer les évaluateurs pairs. Réessayez."
        },
        upward: {
            title: "Assigner des évaluateurs ascendants",
            description: "Choisissez comment les évaluateurs ascendants sont assignés pour <strong>{{name}}</strong>. Les évaluateurs seront avisés qu'ils doivent remplir cette évaluation.",
            fieldLabel: "Évaluateurs ascendants",
            totalSelected_one: "{{count}} évaluateur sélectionné au total",
            totalSelected_other: "{{count}} évaluateurs sélectionnés au total",
            save_one: "Assigner {{count}} évaluateur",
            save_other: "Assigner {{count}} évaluateurs",
            savedToast_one: "{{count}} évaluateur ascendant enregistré pour {{name}}.",
            savedToast_other: "{{count}} évaluateurs ascendants enregistrés pour {{name}}.",
            saveFailedToast: "Nous n'avons pas pu enregistrer les évaluateurs ascendants. Réessayez."
        }
    },
    RemoveCycleRevieweeDialog: {
        title: "Retirer {{name}} de ce cycle ?",
        body_zero: "Cela retire cette personne du cycle. Aucune évaluation n'a encore été rédigée à son sujet.",
        body_one: "Cela masquera l'évaluation rédigée à son sujet dans ce cycle.",
        body_other: "Cela masquera les {{count}} évaluations rédigées à son sujet dans ce cycle.",
        restorable: "Si cette personne est réintégrée au cycle, ces évaluations redeviendront visibles.",
        removedToast: "{{name}} a été retirée du cycle.",
        removeFailedToast: "Nous n'avons pas pu retirer cette personne. Veuillez réessayer.",
        cancel: "Annuler",
        confirm: "Retirer du cycle",
        removing: "Retrait en cours…"
    },
    CycleRevieweeReviews: {
        noReviews: "Aucune évaluation n'a encore été créée pour cette personne.",
        unknownReviewer: "Évaluateur inconnu",
        dueOn: "Échéance : {{date}}"
    },
    CycleRevieweeStatusBadge: {
        "not-started": "Non commencée",
        "in-progress": "En cours",
        submitted: "Soumise",
        overdue: "En retard",
        "not-submitted": "Non soumise"
    },
    CycleDeliveryBadge: {
        "not-delivered": "Non remise",
        shared: "Partagée",
        acknowledged: "Confirmée"
    },
    CycleRevieweeStateTag: {
        active: "Active",
        upcoming: "À venir",
        entersOn: "Intègre le {{date}}"
    },
    CycleRosterFilters: {
        search: {
            label: "Rechercher des personnes évaluées",
            placeholder: "Rechercher des personnes évaluées"
        },
        status: {
            self: "Auto-évaluation",
            manager: "Évaluation du gestionnaire",
            peer: "Évaluation des pairs",
            upward: "Évaluation ascendante"
        },
        delivery: {
            label: "Remise"
        },
        state: {
            label: "État"
        },
        exceptions: {
            label: "Exceptions",
            countsUnavailable: "Le nombre de personnes n'a pas pu être chargé. Vous pouvez tout de même filtrer."
        },
        selectedCount: "{{count}} sélectionnée(s)",
        remove: "Retirer le filtre",
        clear: "Effacer les filtres"
    },
    RosterAddFilterButton: {
        label: "Ajouter un filtre",
        applied: "Appliqué",
        back: "Retour aux filtres"
    },
    CycleRevieweeExceptions: {
        "no-manager": "Aucun gestionnaire assigné",
        "no-peer-reviewers": "Aucun évaluateur pair",
        "no-upward-reviewers": "Aucun évaluateur ascendant",
        deactivated: "Désactivée"
    },
    ReviewCycleDetailView: {
        addReviewees: "Ajouter des personnes évaluées",
        selectAllUnavailable: {
            searchTerm: "Effacez la recherche pour sélectionner toutes les personnes correspondantes. Vous pouvez encore cocher des lignes une à une.",
            revieweeStates: "Effacez le filtre État pour sélectionner toutes les personnes correspondantes. Vous pouvez encore cocher des lignes une à une."
        },
        breadcrumbAriaLabel: "Fil d'Ariane",
        notLaunched: "Ce cycle n'est pas encore lancé, il n'y a donc aucune progression à afficher.",
        progressUnavailable: "Impossible de charger la progression pour cette sélection. Les personnes évaluées ci-dessous sont à jour.",
        nextIntake: "Prochaines intégrations le {{date}}",
        totalCount_one: "{{count}} personne évaluée",
        totalCount_other: "{{count}} personnes évaluées",
        noReviewees: "Vous n'avez accès à aucune personne évaluée dans ce cycle.",
        noMatchingReviewees: "Aucune personne évaluée ne correspond aux filtres appliqués.",
        error: "Impossible de charger ce cycle d'évaluation",
        liveRegion: {
            loading: "Chargement du cycle d'évaluation",
            loadingMoreAnnouncement: "Chargement d'autres personnes évaluées",
            loadedMore_one: "{{count}} personne évaluée de plus chargée",
            loadedMore_other: "{{count}} personnes évaluées de plus chargées",
            results_one: "{{count}} personne évaluée",
            results_other: "{{count}} personnes évaluées",
            sorted: {
                name: "Personnes évaluées triées par nom",
                "entry-date": "Personnes évaluées triées par date d'intégration"
            }
        }
    },
    Errors: {
        reassurance: "Rien n'est perdu. Réessayez dans un instant.",
        retry: "Réessayer",
        refreshBanner: "Impossible d'actualiser la liste. Les résultats précédents sont affichés."
    },
    CycleNineBoxGrid: {
        percentage: "{{percentage}} %",
        notPlaced: "Non positionné",
        placementRatings: "Performance {{performance}} · Potentiel {{potential}}",
        axis: {
            performance: "Performance",
            potential: "Potentiel",
            low: "Bas",
            high: "Élevé"
        },
        band: {
            Low: "Bas",
            Medium: "Moyen",
            High: "Élevé"
        },
        cell: {
            enigma: "Énigme",
            growth: "Croissance",
            stars: "Étoiles",
            dilemma: "Dilemme",
            core: "Noyau",
            "high-impact": "Fort impact",
            risk: "Risque",
            effective: "Efficace",
            trusted: "De confiance",
            ariaLabel: "{{label}}, {{count}} positionnés, {{percentage}} pour cent. Performance {{performance}}, potentiel {{potential}}.",
            explainerAriaLabel: "Ce que signifie {{label}}"
        },
        guidance: {
            risk: "Ne répond pas aux attentes avec des indicateurs limités de croissance future. Adressez la situation directement par un plan d'amélioration de la performance ou explorez si un autre rôle serait plus adapté.",
            dilemma: "Possède une certaine capacité de croissance, mais ne répond pas aux attentes de performance actuellement. Identifiez les causes profondes et fixez des objectifs précis et mesurables. C'est un point de décision.",
            enigma: "Fort potentiel, mais ne livre pas aujourd'hui. Peut être nouveau dans le rôle, mal aligné ou confronté à des obstacles. Diagnostiquez ce qui bloque la performance et établissez un échéancier clair pour l'amélioration.",
            effective: "Répond aux attentes de base sans trajectoire de croissance significative. Assurez la clarté du rôle et maintenez l'engagement. N'investissez pas excessivement au détriment des talents à plus fort potentiel.",
            core: "Répond aux attentes et représente le socle stable de l'équipe. Investissez dans le développement des compétences et assurez-vous qu'il se sente valorisé. Le désengagement ici est un risque silencieux.",
            growth: "Montre un fort potentiel de croissance, mais ne l'a pas encore traduit en haute performance constante. Concentrez-vous sur combler l'écart de performance par le coaching et des attentes claires.",
            trusted: "Un expert fiable qui livre de manière constante dans son rôle actuel. Respectez son expertise, récompensez son impact et évitez de le pousser vers des rôles qui ne lui conviennent pas.",
            "high-impact": "Livre de solides résultats et pourrait avoir de la marge pour croître avec le bon accompagnement. Reconnaissez ses contributions et explorez si un investissement ciblé peut libérer davantage de potentiel.",
            stars: "Dépasse constamment les attentes et démontre une capacité claire à assumer des responsabilités plus larges. Priorisez la rétention, les mandats de développement et la planification de la relève."
        }
    },
    ReviewCycleCalibration: {
        totalCount_one: "{{count}} personne évaluée",
        totalCount_other: "{{count}} personnes évaluées",
        error: "Nous n'avons pas pu charger la calibration de ce cycle",
        columns: {
            reviewee: "Personne évaluée",
            placement: "Positionnement 9 cases",
            reviewScore: "Score d'évaluation"
        },
        noReviewees: "Aucune personne évaluée n'est visible pour vous dans ce cycle.",
        noMatches: "Aucune personne évaluée ne correspond à votre recherche.",
        stats: {
            groupAverage: "Score moyen",
            outOf: "/ {{scale}}",
            scoredOf: "{{scored}} personnes notées sur {{total}}",
            nobodyScored: "Personne n'a encore été noté",
            withheld: "Trop peu de personnes notées pour afficher un chiffre",
            vsCycle: "c. tout le cycle",
            gap: "{{sign}}{{gap}}",
            above: "Au-dessus de la moyenne",
            below: "Sous la moyenne",
            inLine: "Conforme au cycle"
        },
        grid: {
            expand: "Afficher la grille 9 cases",
            hide: "Masquer la grille 9 cases",
            noPlacement: "Ce cycle n'évalue pas la performance et le potentiel : il n'y a donc aucun positionnement à afficher."
        },
        cellChip: {
            clear: "Effacer cette sélection"
        },
        row: {
            expand: "Afficher les détails de calibration de {{name}}",
            collapse: "Masquer les détails de calibration de {{name}}",
            notRated: "Pas encore noté",
            unknownMember: "Membre inconnu"
        },
        search: {
            placeholder: "Trouver une personne évaluée",
            ariaLabel: "Trouver une personne évaluée"
        },
        liveRegion: {
            loading: "Chargement de la calibration du cycle",
            loadingMoreAnnouncement: "Chargement d'autres personnes évaluées",
            loadedMore_one: "{{count}} personne évaluée de plus chargée",
            loadedMore_other: "{{count}} personnes évaluées de plus chargées",
            results_one: "{{count}} personne évaluée",
            results_other: "{{count}} personnes évaluées"
        }
    },
    CycleCalibrationPanel: {
        liveRegion: {
            loading: "Chargement des données de cette personne évaluée"
        },
        scores: {
            heading: "Scores et évaluations"
        },
        score: {
            review: "Score d'évaluation",
            performance: "Performance",
            potential: "Potentiel",
            explainerAriaLabel: "Comment {{score}} est-il calculé ?",
            outOf: "/ {{scale}}",
            notRated: "Non évalué"
        },
        band: {
            Low: "Bas",
            Medium: "Moyen",
            High: "Élevé"
        },
        benchmarks: {
            heading: "Comparatifs",
            description: "Sur l'ensemble du cycle, et non seulement les personnes que vous pouvez voir.",
            unavailable: "Impossible de charger ces comparatifs. Les scores et la note ci-dessus ne sont pas touchés.",
            versus: "c. {{label}}",
            delta: "{{sign}}{{delta}}",
            none: "Aucun département ni poste enregistré pour cette personne."
        },
        note: {
            label: "Notes de calibration",
            audience: "Visible par les personnes qui gèrent directement cette personne.",
            save: "Enregistrer la note",
            saved: "Note de calibration enregistrée",
            saveFailed: "Impossible d'enregistrer cette note de calibration. Vos modifications sont toujours là — réessayez.",
            unavailable: "Impossible de charger cette note de calibration, elle ne peut donc pas être modifiée pour le moment.",
            openReview: "Ouvrir l'évaluation"
        }
    },
    AddFilterButton: {
        label: "Ajouter un filtre"
    },
    FilterKinds: {
        applied: "Appliqué",
        directManagers: "Gestionnaires directs",
        reportingLine: "Lignes hiérarchiques",
        segment: "Segment",
        department: "Département",
        gender: "Genre",
        workLocation: "Lieu de travail",
        roleLevel: "Niveau de poste",
        jobTitle: "Titre du poste",
        tenure: "Ancienneté",
        track: "Filière"
    },
    FilterBar: {
        remove: "Retirer le filtre",
        me: "Moi",
        valueCount_one: "{{count}} sélectionné",
        valueCount_other: "{{count}} sélectionnés",
        chipAriaLabel: "{{kind}} : {{value}}",
        clear: "Effacer les filtres"
    },
    TrackOptions: {
        manager: "Gestionnaire de personnes",
        individualContributor: "Contributeur individuel"
    },
    DepartmentFilterPanel: {
        title: "Département",
        back: "Retour aux filtres",
        searchPlaceholder: "Rechercher un département",
        empty: "Aucun département disponible",
        noMatches: "Aucun département trouvé",
        loading: "Chargement des départements",
        liveRegion: {
            results_one: "{{count}} département trouvé",
            results_other: "{{count}} départements trouvés"
        },
        error: "Impossible de charger les départements. Veuillez réessayer."
    },
    RoleLevelFilterPanel: {
        title: "Niveau de poste",
        back: "Retour aux filtres",
        searchPlaceholder: "Rechercher un niveau de poste",
        empty: "Aucun niveau de poste disponible",
        noMatches: "Aucun niveau de poste trouvé",
        loading: "Chargement des niveaux de poste",
        liveRegion: {
            results_one: "{{count}} niveau de poste trouvé",
            results_other: "{{count}} niveaux de poste trouvés"
        },
        error: "Impossible de charger les niveaux de poste. Veuillez réessayer."
    },
    JobTitleFilterPanel: {
        title: "Titre du poste",
        back: "Retour aux filtres",
        searchPlaceholder: "Rechercher un titre de poste",
        noResults: "Aucun titre de poste ne correspond à votre recherche.",
        empty: "Aucun titre de poste disponible",
        loading: "Chargement des titres de poste",
        staleError: "Impossible d'actualiser — affichage des derniers résultats.",
        liveRegion: {
            results_one: "{{count}} titre de poste trouvé",
            results_other: "{{count}} titres de poste trouvés",
            loadedMore_one: "{{count}} titre de poste de plus chargé",
            loadedMore_other: "{{count}} titres de poste de plus chargés"
        },
        error: "Impossible de charger les titres de poste. Veuillez réessayer."
    },
    TenureFilterPanel: {
        title: "Ancienneté",
        back: "Retour aux filtres",
        clear: "Effacer l'ancienneté"
    },
    TrackFilterPanel: {
        title: "Filière",
        back: "Retour aux filtres",
        clear: "Effacer la filière"
    },
    GenderFilterPanel: {
        title: "Genre",
        back: "Retour aux filtres",
        searchPlaceholder: "Rechercher un genre",
        empty: "Aucun genre disponible",
        noMatches: "Aucun genre trouvé",
        loading: "Chargement des genres",
        liveRegion: {
            results_one: "{{count}} genre trouvé",
            results_other: "{{count}} genres trouvés"
        },
        error: "Impossible de charger les genres. Veuillez réessayer."
    },
    WorkLocationFilterPanel: {
        title: "Lieu de travail",
        back: "Retour aux filtres",
        searchPlaceholder: "Rechercher un lieu de travail",
        empty: "Aucun lieu de travail disponible",
        noMatches: "Aucun lieu de travail trouvé",
        loading: "Chargement des lieux de travail",
        liveRegion: {
            results_one: "{{count}} lieu de travail trouvé",
            results_other: "{{count}} lieux de travail trouvés"
        },
        error: "Impossible de charger les lieux de travail. Veuillez réessayer."
    },
    DirectManagersFilterPanel: {
        title: "Gestionnaires directs",
        back: "Retour aux filtres",
        myScope: "Moi",
        searchPlaceholder: "Rechercher un gestionnaire",
        empty: "Aucun gestionnaire disponible",
        noResults: "Aucun gestionnaire ne correspond à votre recherche.",
        loading: "Chargement des gestionnaires",
        liveRegion: {
            results_one: "{{count}} gestionnaire trouvé",
            results_other: "{{count}} gestionnaires trouvés",
            loadedMore_one: "{{count}} gestionnaire supplémentaire chargé",
            loadedMore_other: "{{count}} gestionnaires supplémentaires chargés"
        },
        error: "Impossible de charger les gestionnaires. Veuillez réessayer.",
        staleError: "Impossible d'actualiser — affichage des derniers résultats."
    },
    ReportingLineFilterPanel: {
        title: "Lignes hiérarchiques",
        back: "Retour aux filtres",
        myScope: "Toute ma ligne hiérarchique",
        searchPlaceholder: "Rechercher un gestionnaire",
        empty: "Aucun gestionnaire disponible",
        noResults: "Aucun gestionnaire ne correspond à votre recherche.",
        loading: "Chargement des gestionnaires",
        liveRegion: {
            results_one: "{{count}} gestionnaire trouvé",
            results_other: "{{count}} gestionnaires trouvés",
            loadedMore_one: "{{count}} gestionnaire supplémentaire chargé",
            loadedMore_other: "{{count}} gestionnaires supplémentaires chargés"
        },
        error: "Impossible de charger les gestionnaires. Veuillez réessayer.",
        staleError: "Impossible d'actualiser — affichage des derniers résultats."
    },
    SegmentFilterPanel: {
        title: "Segment",
        back: "Retour aux filtres",
        searchPlaceholder: "Rechercher un segment",
        empty: "Aucun segment disponible",
        noResults: "Aucun segment ne correspond à votre recherche.",
        untitled: "Segment sans titre",
        loading: "Chargement des segments",
        liveRegion: {
            results_one: "{{count}} segment trouvé",
            results_other: "{{count}} segments trouvés",
            loadedMore_one: "{{count}} segment supplémentaire chargé",
            loadedMore_other: "{{count}} segments supplémentaires chargés"
        },
        error: "Impossible de charger les segments. Veuillez réessayer.",
        staleError: "Impossible d'actualiser — affichage des derniers résultats."
    },
    ReviewCycleScores: {
        totalCount_one: "{{count}} personne évaluée",
        totalCount_other: "{{count}} personnes évaluées",
        noScoresYet: "Aucune évaluation notée n'a encore été reçue. La répartition apparaîtra à mesure que les scores arriveront.",
        withheldDistribution: "Trop peu de personnes ont été notées pour afficher une répartition sans les identifier.",
        noReviewees: "Vous n'avez accès à aucune personne évaluée dans ce cycle.",
        noMatches: "Aucune personne évaluée ne correspond à votre recherche.",
        error: "Impossible de charger les scores de ce cycle",
        search: {
            placeholder: "Rechercher une personne évaluée",
            ariaLabel: "Rechercher une personne évaluée"
        },
        bandChip: {
            below: "Score inférieur à {{max}}",
            between: "Score de {{min}} à {{max}}",
            atLeast: "Score de {{min}} et plus",
            clear: "Effacer cette sélection"
        },
        sort: {
            ascending: "Trié par score d'évaluation, du plus bas au plus élevé",
            descending: "Trié par score d'évaluation, du plus élevé au plus bas"
        },
        liveRegion: {
            loading: "Chargement des scores du cycle",
            loadingMoreAnnouncement: "Chargement d'autres personnes évaluées",
            loadedMore_one: "{{count}} personne évaluée de plus chargée",
            loadedMore_other: "{{count}} personnes évaluées de plus chargées",
            results_one: "{{count}} personne évaluée",
            results_other: "{{count}} personnes évaluées"
        }
    },
    CycleScoreDistribution: {
        seriesLabel: "Ce cycle"
    },
    ReviewCycleQuestionResults: {
        error: "Impossible de charger les résultats des questions de ce cycle",
        empty: {
            title: "Aucune question fermée",
            description: "Ce cycle ne pose que des questions ouvertes. Ce que ces réponses disent se trouve dans l'onglet Thèmes."
        },
        kind: {
            ariaLabel: "Afficher les questions de type",
            all: "Toutes",
            rating: "Échelles",
            choice: "Choix multiples"
        },
        section: {
            label: "Section {{position}} : {{title}}"
        },
        liveRegion: {
            loading: "Chargement des résultats des questions"
        }
    },
    CycleQuestionBlock: {
        audience: {
            ariaLabel: "Afficher les réponses à « {{question}} » provenant de",
            all: "Toutes"
        },
        meta: {
            responses_one: "{{count}} réponse",
            responses_other: "{{count}} réponses",
            narrowed_one: "{{count}} réponse des évaluateurs {{reviewType}}",
            narrowed_other: "{{count}} réponses des évaluateurs {{reviewType}}",
            singleAudience_one: "Posée aux évaluateurs {{reviewType}} · {{count}} réponse",
            singleAudience_other: "Posée aux évaluateurs {{reviewType}} · {{count}} réponses"
        }
    },
    CycleQuestionAnswers: {
        noResponses: "Aucune réponse pour l'instant. Les résultats apparaissent à mesure que les évaluations sont soumises.",
        withheld: {
            "below-minimum-cohort": "Trop peu de personnes ont répondu pour afficher une répartition sans les identifier."
        },
        average: {
            value: "{{average, number(minimumFractionDigits: 1; maximumFractionDigits: 1)}}",
            outOf: "/ {{scaleMax}} en moyenne"
        },
        answer: {
            percentage: "{{percentage}} %",
            count: "({{count}})",
            valueLabel_one: "{{count}} réponse, {{percentage}} %",
            valueLabel_other: "{{count}} réponses, {{percentage}} %"
        }
    },
    ScoreFormulaExplainer: {
        ariaLabel: "Comment le score d'évaluation est-il calculé?",
        title: "Comment ce score est calculé",
        share: "{{share}} %",
        answerOutOf: "{{value}} / {{scaleMax}}",
        noAnswer: "—",
        perspectiveReviewers_one: "{{perspective}} · {{count}} évaluateur",
        perspectiveReviewers_other: "{{perspective}} · {{count}} évaluateurs",
        mode: {
            "average-all-questions": "La moyenne de toutes les questions à échelle de ce cycle, sur {{scale}}.",
            "average-manager-questions": "La moyenne des questions à échelle de l'évaluation du gestionnaire, sur {{scale}}.",
            custom: "Une combinaison pondérée des questions ci-dessous, sur {{scale}}.",
            "overall-score": "La question de score global du cycle, sur {{scale}}."
        }
    },
    CycleRevieweeScoresTable: {
        ariaLabel: "Personnes évaluées par score d'évaluation",
        unknownMember: "Membre inconnu",
        noScore: "Aucun score d'évaluation pour le moment",
        columns: {
            person: "Personne",
            reviewScore: "Score d'évaluation",
            role: "Poste",
            department: "Département"
        }
    },
    AverageScoreStat: {
        label: "Score d'évaluation moyen",
        unit: "/ {{maxScale}}",
        ariaValue: "{{value}} sur {{maxScale}}",
        noScore: "Aucun score d'évaluation pour le moment",
        basedOnCompletion: "Basé sur {{rate}} % de complétion"
    },
    TotalRevieweesStat: {
        label: "Total des personnes évaluées",
        unit_one: "Personne",
        unit_other: "Personnes"
    },
    ScoreBucketSelector: {
        label: "Tranches de scores",
        whole: "Large",
        half: "Moyenne",
        quarter: "Détaillée",
        unavailable: "Trop de comparaisons affichées pour découper l'échelle aussi finement"
    },
    ReviewScoreHistogram: {
        hint: "Sélectionnez une barre pour filtrer la liste ci-dessous",
        percentage: "{{percentage}} %",
        band: {
            ariaLabel_one: "{{label}}, {{count}} personne, {{percentage}} %",
            ariaLabel_other: "{{label}}, {{count}} personnes, {{percentage}} %"
        },
        bar: {
            ariaLabel_one: "{{series}}, {{label}}, {{count}} personne, {{percentage}} %",
            ariaLabel_other: "{{series}}, {{label}}, {{count}} personnes, {{percentage}} %"
        }
    },
    ScoreBandRanges: {
        below: "< {{max}}",
        between: "{{min}}–{{max}}",
        atLeast: "≥ {{min}}"
    },
    ReviewCycleThemes: {
        strengths: {
            title: "Forces"
        },
        opportunities: {
            title: "Occasions de progression"
        },
        empty: "Aucune réponse écrite de ce cycle n'a encore été classée par thème.",
        emptyNoThemes: "Les réponses écrites de cette portée ne font ressortir aucun thème récurrent.",
        emptyScoped: "Personne dans cette portée n'a soumis de réponse écrite. Essayez de retirer un filtre pour élargir les résultats.",
        derivation: {
            title: "Comment est-ce calculé?",
            body: "À la soumission d'une évaluation, ses réponses écrites sont analysées à partir d'un ensemble fixe de douze thèmes, et chaque mention est classée selon ce qui a réellement été écrit plutôt que déduit. Chaque barre couvre l'ensemble de la cohorte : le reste correspond aux personnes pour qui le thème n'a jamais été soulevé. Rien ici n'est attribué à une seule personne évaluatrice ou évaluée - considérez ces données comme un indicateur, non comme une source de vérité."
        },
        liveRegion: {
            loading: "Chargement des thèmes d'évaluation"
        }
    },
    ThemesColumn: {
        strengthsEmpty: "Aucun thème n'a reçu plus d'éloges que de critiques.",
        watchOutsEmpty: "Chaque thème mentionné figure déjà dans les forces."
    },
    ThemeHeadlineCard: {
        labels: {
            strength: "Principales forces",
            watchArea: "Point critique",
            toMonitor: "À surveiller"
        },
        body: {
            strength_one: "Sur {{mentions}} mentions de thèmes, {{first}} est la force la plus nette.",
            strength_other: "Sur {{mentions}} mentions de thèmes, les forces les plus nettes sont : {{first}}, {{second}}.",
            watchArea_one: "Les critiques dépassent le plus les éloges dans {{first}}.",
            watchArea_other: "Les critiques dépassent le plus les éloges dans : {{first}}, {{second}}.",
            toMonitor_one: "{{first}} se situe près de l'équilibre. Ce thème mérite d'être surveillé au prochain cycle.",
            toMonitor_other: "Les plus près de l'équilibre : {{first}}, {{second}}. Les deux méritent d'être surveillés au prochain cycle."
        },
        empty: {
            strength: "Aucun thème souvent mentionné ne se démarque comme une force nette.",
            watchArea: "Aucun thème souvent mentionné n'a de critiques dépassant nettement les éloges.",
            toMonitor: "Aucun thème souvent mentionné ne se situe près de l'équilibre."
        }
    },
    ThemeSentimentBar: {
        segment: "{{percent}} % {{label}}",
        segmentSeparator: ", ",
        labels: {
            Positive: "positif",
            Mixed: "mitigé",
            Negative: "négatif",
            remaining: "non mentionné"
        }
    },
    CycleBuilderForm: {
        pageTitle: "Configuration du cycle d'évaluation",
        nav: {
            label: "Aller à une section",
            sectionIssues_one: "1 élément à corriger",
            sectionIssues_other: "{{count}} éléments à corriger",
            advanced: "Avancé",
            position: "{{position}} sur {{total}}"
        },
        sections: {
            basics: "Informations de base",
            reviewForm: "Formulaire d'évaluation",
            schedule: "Planification",
            reviewees: "Personnes évaluées",
            advanced: "Paramètres avancés",
            notifications: "Sommaire des notifications"
        },
        notificationsDescription: "Tout ce que ce cycle enverra, et à qui.",
        advancedDescription: {
            withAcknowledgment: "Score d'évaluation, grille 9 cases et prise de connaissance formelle.",
            withoutAcknowledgment: "Score d'évaluation et grille 9 cases."
        },
        advancedRows: {
            reviewScore: {
                label: "Score d'évaluation",
                hint: "Un seul chiffre par personne, calculé à partir de ses réponses aux questions à échelle."
            },
            nineBox: {
                label: "Grille 9 cases",
                hint: "Situe chaque personne selon sa performance et son potentiel."
            },
            acknowledgment: {
                label: "Prise de connaissance",
                hint: "Les personnes évaluées confirment avoir lu leurs résultats."
            }
        },
        name: {
            label: "Nom du cycle",
            placeholder: "p. ex. Évaluation de rendement S1 2026"
        },
        description: {
            label: "Description",
            placeholder: "Expliquez aux évaluateurs l'objectif de ce cycle"
        },
        reviewTypes: {
            label: "Types d'évaluation"
        },
        acknowledgment: {
            label: "Exiger une prise de connaissance formelle",
            eligible: "Une fois la prise de connaissance faite, une évaluation ne peut plus être retirée du partage.",
            lockedHelperText: "Ce paramètre ne peut plus être modifié après le lancement du cycle."
        },
        scheduleErrors: {
            evaluationEndBeforeStart: "La période d'évaluation doit se terminer à sa date de début ou après.",
            closeNotAfterOpen: "Le cycle doit se fermer après sa date d'ouverture.",
            closeNotAfterDueDate: "Le cycle doit se fermer après le {{date}}, sa dernière date limite de soumission.",
            closeNotAfterLastOpening: "Le cycle doit se fermer après l'ouverture de la dernière évaluation.",
            closeNotAfterFinalDueDate: "Le cycle doit se fermer après le {{date}}, la dernière échéance de la dernière personne évaluée.",
            dueDateBeforeOpen: {
                self: "L'échéance des auto-évaluations ne peut pas précéder le lancement du cycle.",
                manager: "L'échéance des évaluations par le gestionnaire ne peut pas précéder le lancement du cycle.",
                peer: "L'échéance des évaluations par les pairs ne peut pas précéder le lancement du cycle.",
                upward: "L'échéance des évaluations ascendantes ne peut pas précéder le lancement du cycle."
            }
        },
        launchIssues: {
            withSection: "{{section}} : {{message}}",
            name: "Le cycle doit avoir un nom.",
            peerCount: "Évaluateurs pairs : entrez un nombre de {{min}} à {{max}}.",
            reviewForm: {
                noQuestions: "Ajoutez au moins une question.",
                untitledSection: "Il manque un nom de section.",
                emptySection: "Aucune question.",
                noAudience: "Posée à personne.",
                untitledQuestion: "Il manque le texte de la question.",
                tooFewChoices: "Il faut au moins {{count}} options.",
                unlabelledChoice: "Une option n'a pas de libellé.",
                tooFewRatingPoints: "Il faut au moins {{count}} points d'échelle.",
                unlabelledRatingPoint: "Un point d'échelle n'a pas de libellé.",
                reviewTypeWithoutRequiredQuestion: "{{reviewType}} n'a aucune question obligatoire."
            },
            schedule: {
                evaluationPeriod: "Définissez la période d'évaluation.",
                evaluationStartInFuture: "La période d'évaluation doit commencer aujourd'hui ou avant.",
                dueDate: "Définissez l'échéance : {{reviewType}}.",
                dueDateOffset: "Définissez l'échéance des évaluations : {{reviewType}}.",
                intake: "Définissez la durée d'admission.",
                openDate: "Définissez la date d'ouverture.",
                openDateInPast: "La date d'ouverture est passée.",
                closeDate: "Définissez la date de fermeture."
            },
            reviewees: {
                noOneIncluded: "Personne n'est inclus pour l'instant.",
                nobodyMatches: "Personne ne correspond à cette configuration."
            },
            scoreFormula: {
                review: {
                    components: "Score d'évaluation : chaque élément doit avoir une question d'évaluation et un évaluateur.",
                    weights: "Score d'évaluation : les pondérations doivent totaliser 100 %."
                },
                performance: {
                    components: "Performance : chaque élément doit avoir une question d'évaluation et un évaluateur.",
                    weights: "Performance : les pondérations doivent totaliser 100 %."
                },
                potential: {
                    components: "Potentiel : chaque élément doit avoir une question d'évaluation et un évaluateur.",
                    weights: "Potentiel : les pondérations doivent totaliser 100 %."
                }
            },
            acknowledgmentNotShared: "Aucune réponse n'est partagée avec la personne évaluée."
        },
        launch: {
            launched: "Votre cycle a été lancé",
            scheduled: "Votre cycle a été planifié",
            failed: "Votre cycle n'a pas pu être lancé. Veuillez réessayer plus tard."
        }
    },
    CycleScheduleSection: {
        frozenAfterLaunchTooltip: "Ce réglage ne peut plus changer après le lancement du cycle. Des évaluations sont déjà planifiées selon cet horaire.",
        frozenStartDateTooltip: "Cette date ne peut plus changer. Les inscriptions ont commencé le {{date}} dans le fuseau horaire de votre organisation ({{timeZone}}).",
        type: {
            label: "Type de cycle",
            focal: {
                label: "Période fixe",
                description: "Tout le monde est évalué en même temps, dans une seule période partagée."
            },
            hireDate: {
                label: "Date d'embauche",
                description: "Chaque personne est évaluée à sa propre date."
            },
            basedOn: {
                label: "Selon",
                anniversary: "Anniversaire de la date d'embauche",
                milestone: "Seuil d'ancienneté"
            },
            grouping: {
                label: "Regroupement",
                none: "Aucun",
                weekly: "Cohortes hebdomadaires",
                monthly: "Cohortes mensuelles"
            },
            milestone: {
                label: "Seuil",
                "30": "Après 30 jours",
                "60": "Après 60 jours",
                "90": "Après 90 jours",
                "180": "Après 6 mois",
                "365": "Après 1 an"
            }
        },
        evaluationPeriod: {
            label: "Période d'évaluation",
            hint: "Le travail évalué.",
            startDate: "Date de début",
            endDate: "Date de fin",
            lengthLabel: "Durée de la période d'évaluation",
            lengthPrefix: "Évaluer les",
            sinceHirePrefix: "Évaluer",
            lengthSuffix: "qui précèdent cette date.",
            months_one: "{{count}} mois",
            months_other: "{{count}} mois",
            sinceHire: "tout depuis son embauche",
            placeholder: "Choisissez une durée"
        },
        mode: {
            automatic: "Automatiquement",
            manual: "Manuellement"
        },
        open: {
            focalLabel: "Lancement du cycle",
            hireDateLabel: "Ouverture des évaluations",
            focalDateLabel: "Date de lancement",
            hireDateDateLabel: "Date d'ouverture",
            stillManual: "Vous pourrez quand même lancer le cycle manuellement.",
            intake: {
                label: "Les évaluations continuent d'ouvrir pendant",
                unitLabel: "Unité de durée",
                weeks: "semaines",
                months: "mois",
                suffix: "après l'ouverture de la première évaluation",
                lastOpening: "La dernière évaluation s'ouvre le {{date}}. Un cycle ne peut pas s'étendre sur plus d'un an.",
                cap: "Un cycle ne peut pas s'étendre sur plus d'un an."
            }
        },
        close: {
            label: "Fermeture du cycle",
            hint: "Toutes les évaluations sont verrouillées et passent en lecture seule.",
            dateLabel: "Date de fermeture",
            floor: "Doit être le {{date}} ou plus tard, pour laisser à tout le monde le temps de terminer."
        },
        lateSubmissions: {
            label: "Soumission en retard",
            notAccepted: "Non acceptée",
            acceptedFor: "Acceptée pendant…",
            indefinitely: "Acceptée indéfiniment",
            daysLabel: "Jours après l'échéance de l'évaluation",
            daysSuffix_one: "jour après l'échéance de l'évaluation",
            daysSuffix_other: "jours après l'échéance de l'évaluation",
            help: {
                notAccepted: "Les évaluations se verrouillent une fois l'échéance passée.",
                acceptedFor: "Après ce délai, l'évaluation se verrouille et devient en lecture seule.",
                indefinitely: "Les évaluations ne se verrouillent jamais. Vous pouvez fermer et verrouiller le cycle vous-même."
            }
        },
        reviewWindows: {
            label: "Échéances",
            focalHint: "Les évaluations en retard peuvent toujours être soumises jusqu'à la fermeture du cycle."
        },
        recurrence: {
            label: "Récurrence",
            switchLabel: "Répéter ce cycle",
            nextCycle: "Le prochain cycle débute le {{startDate}}. Son brouillon est créé un mois à l'avance, le {{draftDate}}.",
            nextCycleFromLaunch: "Le prochain cycle débute une période d'évaluation plus tard, à partir du lancement de celui-ci. Son brouillon est créé un mois à l'avance.",
            nextCycleFromLastOpening: "Le prochain cycle débute le lendemain de l'ouverture de la dernière évaluation. Son brouillon est créé un mois à l'avance."
        }
    },
    CycleReviewWindows: {
        reviewTypes: {
            self: "Auto-évaluation",
            manager: "Évaluation par le gestionnaire",
            peer: "Évaluation par les pairs",
            upward: "Évaluation ascendante"
        },
        table: {
            caption: "Échéances par type d'évaluation",
            reviewType: "Type d'évaluation",
            deadline: "Date limite de soumission",
            dueAfter: "Échéance après le début de la rédaction",
            days: "jours",
            deadlineLabel: "{{reviewType}} : date limite de soumission",
            dueAfterLabel: "{{reviewType}} : échéance après le début de la rédaction, en jours"
        },
        timeline: {
            sliderLabel: "{{reviewType}} : échéance",
            dueOn: "Échéance le {{date}}",
            dueOnDay: "Échéance au jour {{day}}",
            noDueDate: "Aucune échéance",
            launch: "Lancement",
            day: "Jour {{day}}",
            overflow: {
                self: "Les auto-évaluations se verrouillent après la fermeture du cycle.",
                manager: "Les évaluations par le gestionnaire se verrouillent après la fermeture du cycle.",
                peer: "Les évaluations par les pairs se verrouillent après la fermeture du cycle.",
                upward: "Les évaluations ascendantes se verrouillent après la fermeture du cycle."
            }
        }
    },
    CycleNotificationsSummary: {
        subheading: "Voici un aperçu de toutes les notifications automatisées qui seront envoyées pendant le cycle d'évaluation de performance. Ces notifications permettent de tenir les participants informés et d'assurer que les évaluations sont complétées dans les délais.",
        filterLabel: "Filtrer par destinataire",
        tableLabel: "Notifications automatisées",
        columns: {
            notification: "Notification",
            goesTo: "Destinataires",
            sent: "Envoi"
        },
        audiences: {
            all: "Tous",
            reviewer: "Évaluateur",
            directManager: "Gestionnaire immédiat",
            reviewee: "Personne évaluée",
            peerReviewer: "Pair",
            upwardReviewer: "Évaluateur ascendant"
        },
        notifications: {
            reviewCycleKickoff: {
                title: "Lancement du cycle d'évaluation",
                description: "Informe les participants que le cycle d'évaluation a été lancé et fournit un aperçu du processus.",
                trigger: "Envoyé au début du cycle"
            },
            peerReviewersSelection: {
                title: "Sélection des pairs",
                description: "Informe les gestionnaires de sélectionner les pairs pour leurs subordonnés directs.",
                trigger: "Envoyé au début du cycle"
            },
            peerReviewRequest: {
                title: "Demande d'évaluation par les pairs",
                description: "Informe les participants de compléter leurs évaluations par les pairs.",
                trigger: "Envoyé lorsque les pairs sont sélectionnés"
            },
            upwardReviewersSelection: {
                title: "Sélection des évaluateurs ascendants",
                description: "Informe les gestionnaires de sélectionner les évaluateurs ascendants pour leurs subordonnés directs.",
                trigger: "Envoyé au début du cycle"
            },
            upwardReviewRequest: {
                title: "Demande d'évaluation ascendante",
                description: "Informe les participants de compléter leurs évaluations ascendantes.",
                trigger: "Envoyé lorsque les évaluateurs ascendants sont sélectionnés"
            },
            temporaryManagerAssignation: {
                title: "Attribution de gestionnaire immédiat temporaire",
                description: "Informe les participants qu'ils ont été assignés comme gestionnaire immédiat temporaire pour les subordonnés directs d'autres gestionnaires.",
                trigger: "Envoyé lors de l'assignation comme gestionnaire immédiat temporaire"
            },
            reviewReminder: {
                title: "Rappel d'évaluation",
                description: "Rappelle aux participants de compléter leurs évaluations avant la date limite.",
                trigger: "Envoyé 3 jours ouvrables avant la date limite de soumission"
            },
            reviewDueToday: {
                title: "Évaluation à remettre aujourd'hui",
                description: "Rappelle aux participants que leur évaluation est à remettre aujourd'hui.",
                trigger: "Envoyé à la date limite de soumission"
            },
            reviewOverdue: {
                title: "Évaluation en retard",
                description: "Informe les participants que leur évaluation est en retard.",
                trigger: "Envoyé après la date limite de soumission"
            },
            submitConfirmation: {
                title: "Confirmation de soumission d'évaluation",
                description: "Confirme aux participants que leurs évaluations ont été soumises avec succès.",
                trigger: "Envoyé lorsque l'évaluation est soumise"
            },
            managerDailyDigest: {
                title: "Sommaire quotidien du gestionnaire",
                description: "Fournit aux gestionnaires un résumé quotidien de l'activité de leurs subordonnés directs : évaluations complétées, évaluations en retard, et subordonnés directs récemment ajoutés ou retirés.",
                trigger: "Envoyé quotidiennement lorsqu'il y a de l'activité à signaler"
            },
            reviewShared: {
                title: "Évaluation partagée",
                description: "Informe les personnes évaluées que l'évaluation par le gestionnaire, par les pairs et/ou ascendante a été partagée avec elles.",
                trigger: "Envoyé lorsque les évaluations sont partagées"
            },
            newlyAddedParticipant: {
                title: "Nouveaux participants ajoutés",
                description: "Informe les participants qu'ils ont été ajoutés à un cycle en cours après son lancement et que des tâches leur sont attribuées.",
                trigger: "Envoyé lorsqu'ils sont ajoutés à un cycle en cours"
            }
        }
    },
    CycleAudienceSection: {
        includeLabel: "Qui est inclus",
        exclude: "Exclure des personnes"
    },
    AudienceField: {
        placeholder: "Rechercher des personnes et des segments",
        groups: {
            scope: "Portée",
            segments: "Segments",
            people: "Personnes"
        },
        everyone: "Toute l'organisation",
        segmentOption_one: "{{name}} · {{count}} membre",
        segmentOption_other: "{{name}} · {{count}} membres",
        noResults: "Aucun résultat.",
        loading: "Chargement des résultats",
        error: "Une erreur s'est produite",
        remove: "Retirer {{name}}",
        unidentifiedSegment: "Segment non identifié",
        unknownTeam: "Équipe inconnue",
        unknownMember: "Membre inconnu",
        limitReached: "Vous avez atteint la limite de {{max}} segments ou membres"
    },
    AudienceConditionPopover: {
        addCondition: "Ajouter une condition",
        dialogLabel: "Rédiger une condition",
        loading: "Chargement des champs des employés",
        error: "Impossible de charger vos champs d'employés.",
        retry: "Réessayer",
        matchCount_one: "{{count}} personne correspond",
        matchCount_other: "{{count}} personnes correspondent",
        countLoading: "Vérification des correspondances",
        matchTypeFixed: "La correspondance à au moins une règle n'est pas offerte ici.",
        cancel: "Annuler",
        save: "Enregistrer le segment et l'ajouter",
        savedToast: "Segment « {{name}} » enregistré",
        saveErrorToast: "Impossible d'enregistrer ce segment. Réessayez."
    },
    AudiencePreview: {
        heading_one: "{{count}} personne évaluée",
        heading_other: "{{count}} personnes évaluées",
        searchPlaceholder: "Rechercher par nom",
        searchLabel: "Rechercher dans la liste par nom",
        nobodyIncluded: "Personne n'est encore inclus. Ajoutez des personnes ou des segments ci-dessus.",
        nobodyMatches: "Personne ne correspond à cette configuration.",
        searchEmpty: "Personne ici ne correspond à « {{query}} ».",
        tableLabel: "Personnes évaluées incluses dans ce cycle",
        columns: {
            person: "Personne",
            hireDate: "Embauche",
            reviewOpens: "Ouverture de l'évaluation"
        },
        atLaunch: "Au lancement",
        noEntryDate: "Non définie",
        noHireDate: "Aucune date d'embauche",
        showing: "Affichage de {{shown}} sur {{total}}.",
        unknownMember: "Membre inconnu",
        unavailable: "L'aperçu n'est pas disponible pour cette organisation.",
        error: {
            title: "Une erreur s'est produite",
            retry: "Réessayer"
        },
        liveRegion: {
            loading: "Chargement des personnes évaluées",
            loadedMore_one: "{{count}} personne évaluée de plus chargée",
            loadedMore_other: "{{count}} personnes évaluées de plus chargées"
        }
    },
    ReviewScoreField: {
        scaleVisibleLabel: "Échelle",
        scaleOption: "Sur {{scale}}",
        modeLabel: "Formule",
        mode: {
            "average-manager-questions": {
                label: "Moyenne des réponses de cote du gestionnaire",
                description: "La moyenne de toutes les réponses de cote données par le gestionnaire."
            },
            "average-all-questions": {
                label: "Moyenne des réponses de cote de tous les évaluateurs",
                description: "La moyenne de toutes les réponses de cote, tous évaluateurs confondus."
            },
            custom: {
                label: "Formule personnalisée",
                description: "Choisissez quelles cotes comptent, et dans quelle proportion."
            }
        }
    },
    NineBoxField: {
        inclusionLabel: "Inclure une grille 9 cases",
        performanceLabel: "Performance",
        performanceMode: {
            "overall-score": {
                label: "Score d'évaluation",
                description: "Utiliser le score que ce cycle calcule déjà."
            },
            custom: {
                label: "Personnalisé",
                description: "Choisissez des questions de cote précises et attribuez un poids à chacune."
            }
        },
        potentialLabel: "Potentiel",
        potentialMode: {
            "single-question": {
                label: "Une seule question",
                description: "Calculer cet axe à partir d'une seule question de cote."
            },
            custom: {
                label: "Personnalisé",
                description: "Choisissez des questions de cote précises et attribuez un poids à chacune."
            }
        },
        questionLabel: "Question",
        questionPlaceholder: "Sélectionner une question",
        reviewTypeLabel: "Type d'évaluation",
        reviewTypePlaceholder: "Sélectionner",
        scaleLabel: "Échelle de rapport",
        reviewType: {
            manager: "Gestionnaire",
            self: "Auto-évaluation",
            peer: "Pair",
            upward: "Ascendante"
        }
    },
    NoRatingQuestionsHint: {
        message: "Aucune question de cote : ce cycle ne produira pas de score.",
        addRatingQuestion: "Ajouter une question de cote"
    },
    ScoreFormulaQuestionSelect: {
        untitledQuestion: "Question sans titre",
        addRatingQuestion: "Ajouter une question de cote"
    },
    ScoreFormulaComponentsField: {
        questionColumn: "Question",
        reviewTypeColumn: "Type d'évaluation",
        weightColumn: "Poids",
        questionPlaceholder: "Sélectionner une question",
        reviewTypePlaceholder: "Sélectionner",
        weightPlaceholder: "Égal",
        addComponent: "Ajouter une entrée",
        removeComponent: "Retirer la question",
        weightSum: "Total : {{percent}} %",
        weightSumRequirement: "Les poids doivent totaliser 100 %.",
        weightAuto: "Auto",
        reviewType: {
            manager: "Gestionnaire",
            self: "Auto-évaluation",
            peer: "Pair",
            upward: "Ascendante"
        }
    },
    CycleReviewTypesField: {
        legend: "Types d'évaluation",
        lastReviewType: "{{description}} Un cycle doit compter au moins un type d'évaluation, celui-ci ne peut donc pas être désactivé.",
        lockedHelperText: "Ce paramètre ne peut plus être modifié après le lancement du cycle.",
        nominationModeDisabledDescription: "Ce paramètre ne peut plus être modifié.",
        reviewTypes: {
            self: {
                label: "Auto-évaluation",
                description: "La personne évaluée apprécie son propre travail."
            },
            manager: {
                label: "Évaluation par le gestionnaire",
                description: "Son gestionnaire direct l'évalue."
            },
            peer: {
                label: "Évaluation par les pairs",
                description: "Les collègues avec qui elle travaille l'évaluent."
            },
            upward: {
                label: "Évaluation ascendante",
                description: "Les personnes qui lui sont subordonnées l'évaluent."
            }
        },
        peer: {
            count: {
                label: "Nombre suggéré d'évaluateurs pairs",
                description: "Les gestionnaires les désignent à l'ouverture du cycle."
            }
        },
        upward: {
            nomination: {
                label: "Comment les évaluateurs sont choisis",
                "direct-reports": {
                    label: "Tous les subordonnés directs"
                },
                "reporting-line": {
                    label: "Toute la ligne hiérarchique",
                    description: "Toutes les personnes sous elle, à tout niveau."
                },
                manual: {
                    label: "Manuel",
                    description: "Un administrateur ou un gestionnaire les choisit."
                }
            }
        },
        attribution: {
            label: "Noms des auteurs",
            anonymous: {
                label: "Masqués aux personnes évaluées",
                description: "Les gestionnaires et les cadres au-dessus d'elles voient tout de même qui a écrit quoi."
            },
            identified: {
                label: "Visibles aux personnes évaluées"
            }
        }
    },
    QuestionnaireBuilder: {
        addQuestion: "Question",
        addSection: "Section",
        outlineLabel: "Contenu du questionnaire",
        rowIssues_one: "1 élément à corriger",
        rowIssues_other: "{{count}} éléments à corriger",
        limitReached: "Vous avez atteint la limite de {{count}} sections et questions.",
        empty: "Ajoutez une question pour commencer à créer le formulaire d'évaluation.",
        untitledQuestion: "Question sans titre",
        untitledSection: "Section sans titre",
        reorderSection: "Réorganiser la section",
        reorderQuestion: "Réorganiser la question",
        sectionPosition: "{{name}}, section {{position}} sur {{total}}",
        questionPosition: "{{name}}, question {{position}} sur {{total}} dans {{section}}",
        questionNumber: "Question {{number}}",
        sectionTitlePlaceholder: "Ajouter un nom de section",
        sectionDescriptionPlaceholder: "Expliquez sur quoi porte cette section (facultatif)",
        questionTitlePlaceholder: "Que voulez-vous demander?",
        questionDescriptionPlaceholder: "Description (facultatif)",
        duplicateQuestion: "Dupliquer la question",
        deleteQuestion: "Supprimer la question",
        deleteSection: "Supprimer la section",
        kinds: {
            text: "Texte libre",
            rating: "Échelle d'évaluation",
            choice: "Choix multiple"
        },
        answerLabel: "Réponse",
        kindLabel: "Type de réponse",
        kindLocked: "Ce paramètre ne peut plus être modifié après le lancement du cycle.",
        textPreview: "Réponse en texte libre",
        addChoice: "Ajouter un choix",
        choicePlaceholder: "Choix {{number}}",
        deleteChoice: "Supprimer le choix",
        allowMultiple: "Autoriser la personne à choisir plus d'une réponse",
        addRatingPoint: "Ajouter un point",
        ratingPointPlaceholder: "Libellé du point {{number}}",
        ratingPointDescriptionLabel: "Description du point {{number}}",
        ratingPointDescriptionPlaceholder: "Ce que ce point signifie (facultatif)",
        deleteRatingPoint: "Supprimer l'option",
        audiences: {
            self: "Personne évaluée",
            manager: "Gestionnaire",
            peer: "Pairs",
            upward: "Personnes supervisées"
        },
        responses: {
            self: "Ses propres réponses",
            manager: "Les réponses du gestionnaire",
            peer: "Les réponses des pairs",
            upward: "Les réponses des personnes qu'elle supervise"
        },
        whoAnswers: "Qui répond à cette question",
        noReviewTypes: "Ce cycle ne comporte aucune évaluation pour l'instant.",
        required: "Obligatoire",
        sharedWithReviewee: "Partagé avec la personne évaluée",
        nobodyAsked: "Personne n'a encore cette question à remplir.",
        rewordFor: "Reformuler pour",
        rewordingFor: "Formulation pour {{audience}}",
        useSharedWording: "Utiliser la formulation commune pour {{audience}}",
        issues: {
            noQuestions: "Au moins une section et une question sont obligatoires.",
            emptySection: "Cette section est vide.",
            untitledSection: "Cette section doit avoir un nom.",
            noAudience: "Attribuez cette question à au moins une évaluation.",
            untitledQuestion: "Cette question doit avoir une formulation.",
            tooFewChoices: "Offrez au moins {{count}} choix.",
            unlabelledChoice: "Un choix n'a pas de libellé.",
            tooFewRatingPoints: "Offrez au moins {{count}} options d'échelle.",
            unlabelledRatingPoint: "Un point de l'échelle n'a pas de libellé.",
            tooManySlots: "Vous avez atteint la limite de {{count}} sections et questions.",
            reviewTypeWithoutRequiredQuestion: "{{audience}} doit avoir au moins une question obligatoire."
        }
    },
    CycleBuilderFooter: {
        cancel: "Annuler",
        saving: "Enregistrement en cours. Patientez un instant.",
        saved: "Toutes les modifications ont été enregistrées",
        saveError: "Modifications non enregistrées",
        saveRefused: "Certaines modifications n'ont pas pu être enregistrées",
        launch: "Lancer le cycle",
        schedule: "Planifier le cycle",
        launching: "Lancement…",
        scheduling: "Planification…"
    },
    CycleLaunchIssuesMenu: {
        label_one: "1 problème",
        label_other: "{{count}} problèmes",
        accessibleLabel_one: "1 problème à corriger",
        accessibleLabel_other: "{{count}} problèmes à corriger"
    }
};
